import { render, staticRenderFns } from "./Charity.vue?vue&type=template&id=3b9322cd&"
import script from "./Charity.vue?vue&type=script&lang=ts&"
export * from "./Charity.vue?vue&type=script&lang=ts&"
import style0 from "./Charity.vue?vue&type=style&index=0&id=3b9322cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports